type HeroVideoPlaybackTarget = Pick<
    HTMLVideoElement,
    "load" | "play" | "removeAttribute"
>;

export async function playOrUseAnimatedImage(
    video: HeroVideoPlaybackTarget,
): Promise<boolean> {
    try {
        await video.play();
        return false;
    } catch (error) {
        if (error instanceof DOMException && error.name === "AbortError") {
            return false;
        }

        video.removeAttribute("src");
        video.load();
        return true;
    }
}
